import React, { Suspense } from 'react'
import { SWRConfig } from 'swr'

import { ThemeProvider, styled } from '@creditas/stylitas'
import tokens from '@creditas/tokens'
import { Global } from '@creditas/global'
import { File } from '@creditas/icons'

import { ErrorBoundary } from 'components/ErrorBoundary'
import { AuthProvider } from 'providers/Auth'
import { AblyProvider } from 'providers/Ably'

import { Pages } from './pages'
import { theme } from './theme'

const Container = styled.div`
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
`

const App = () => (
  <SWRConfig
    value={{
      suspense: true,
      revalidateOnFocus: false,
      revalidateOnMount: false,
    }}
  >
    <ThemeProvider theme={{ ...tokens, ...theme }}>
      <Global />
      <Suspense
        fallback={
          <Container>
            <File.Loader />
          </Container>
        }
      >
        <AuthProvider>
          <AblyProvider>
            <ErrorBoundary>
              <Pages />
            </ErrorBoundary>
          </AblyProvider>
        </AuthProvider>
      </Suspense>
    </ThemeProvider>
  </SWRConfig>
)

export default App
